module.exports = __webpack_public_path__ + "static/img/kydbtn.bdbc17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/my/kydbtn.png
// module id = yV9g
// module chunks = 80